module.exports = __webpack_public_path__ + "img/jambyl7.f8bfd679.jpg";